import { IdentityTeam, Team } from '@reg/shared/model';

export class TeamSuggestion {
    public team: IdentityTeam;
    public teamTypeName: string;
    public hasFocus: boolean = false;

    public fillFromTeam(team: IdentityTeam): TeamSuggestion {
        this.team = team;

        if (this.team &&
            this.team.teamType) {
            this.teamTypeName = team.teamType.name;
        }

        return this;
    }

    public fillFromSearchHit(searchHit: Object): TeamSuggestion {
        if (searchHit && searchHit['fields']) {
            const fields: Object = searchHit['fields'];

            this.team = new IdentityTeam();
            this.team.id = searchHit['id'].replace('team_', '');
            this.team.name = this.getSearchHitField('name', fields);
            this.team.abbreviation = this.getSearchHitField('abbreviation', fields);
            this.team.location.name = this.getSearchHitField('location_name', fields);
            this.team.location.city = this.getSearchHitField('location_city', fields);
            this.team.location.state = this.getSearchHitField('location_state', fields);
            this.teamTypeName = this.getSearchHitField('type', fields);
        }

        return this;
    }

    private getSearchHitField(fieldName: string, fields: Object): string {
        if (fields[fieldName]) {
            if (Array.isArray(fields[fieldName])) {
                return fields[fieldName][0];
            }
            return fields[fieldName];
        }
        return null;
    }
}
